module.exports = __webpack_public_path__ + "static/18-e8a015e080c4ec208656a6484448ec79.png";